<template>
  <b-row v-if="showListDefault || activeActivities > 0 || !disabled" :class="p_printActivities ? '' : 'no-print'">
    <b-col md="8" class="text-muted" v-if="!p_showByDefault">
      <label @click="setVisibilityInfo" class="pointer icon">{{ $tc("actionPlan") }}
        <i v-if="!showVisibilityInfo" class="fa fa-angle-down"></i>
        <i v-if="showVisibilityInfo" class="fa fa-angle-up"></i></label>
    </b-col>
    <b-col v-if="info && showVisibilityInfo && reviewActivities.length > 0" md="2" class="mt-2">
      <b-form-checkbox v-model="showReviewers">{{ $t("show") }} {{ $t("reviewers") }}</b-form-checkbox>
    </b-col>
    <b-col v-if="showVisibilityInfo || p_showByDefault" md="12" class="text-muted d-md-block">
      <b-table
        class="table custom-rounded-border pointer small"
        :items="filteredActivities"
        :fields="[
          { key: 'name', label: $tc('activity') },
          { key: 'responsible', label: $tc('responsible') },
          { key: 'deadline_date', label: $t('deadline') },
          { key: 'field4', label: $t('priority') },
          { key: 'status', label: $t('status') }
        ]"
        @row-clicked="(item, index) => editActivity(item, index)"
        stacked="md"
      >
        <template #cell(name)="row">
          {{ row.item.name }}
        </template>

        <template #cell(responsible)="row">
          {{ row.item.responsible ? row.item.responsible.fullName : '' }}
          <span v-if="row.item.controller" class="text-muted">
            <br>
            ({{ row.item.controller.fullName }})
          </span>
        </template>

        <template #cell(deadline_date)="row">
          {{ row.item.deadline_date }}
        </template>

        <template #cell(field4)="row">
          <span v-if="row.item.field4 > 0">
            {{ $t('types.activityConsequenceTypes.' + row.item.field4) }}
          </span>
        </template>

        <template #cell(status)="row">
          <template v-if="row.item.activity_type == 1">
            <b-badge :variant="rowClass(row.item)">
              {{ $t('types.activitySignTypes.' + row.item.status) }}
            </b-badge>
          </template>
          <template v-if="row.item.activity_type != 1">
            <b-badge :variant="rowClass2(row.item)">
              {{ $t('types.activityStatusTypes.' + row.item.status) }}
            </b-badge>
          </template>
        </template>
      </b-table>
    </b-col>
    <b-col v-if="info || (showVisibilityInfo && (protocol || activities))" md="6" class="mt-2 no-print">
      <b-form-checkbox v-model="showOnlyActive">{{ $t("show") }} {{ $t("only") }} {{ $t("ongoing") }}</b-form-checkbox>
    </b-col>
    <b-col v-if="showVisibilityInfo || p_showByDefault" md="6" class="text-right">
      <b-button v-if="!disabled" @click="editActivity()" variant="outline-secondary">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
      </b-button>
    </b-col>

    <b-modal
      :visible="showActivityModal"
      :title="$tc('activity')"
      centered
      size="lg"
      :hide-header-close="true"
      :hide-footer="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-title="$t('save')"
      :ok-disabled="!saveEnabled || disableModalSave || !saveAllowed"
      :cancel-title="$t('cancel')"
      @signed="signedActivity()"
      @ok="saveActivity()"
      @cancel="cancel()"
    >
      <p class="my-4">
        <activity-modal-form
          :edited-activity="editedActivity"
          :isInfoType="isInfoObject"
          :showEdit="saveAllowed"
          @validInput="enableSave"
          @signed="signedActivity()"
          @signOngoing="modalSignOngoingOn()"
          @signDisabled="modalSignOngoingOff()"
        ></activity-modal-form>
      </p>
    </b-modal>

    <b-modal
      :visible="showSignModal"
      :title="$tc('activity')"
      centered
      :hide-header-close="true"
      :hide-footer="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :ok-title="$t('save')"
      :cancel-title="$t('cancel')"
      :ok-disabled="disableModalSave || !saveAllowed"
      @ok="saveActivity()"
      @cancel="cancel()"
    >
      <p class="my-4">
        <sign-modal-form
          :edited-activity="editedActivity"
          :isInfoType="isInfoObject"
          :showEdit="saveAllowed"
          @signed="signedActivity()"
          @signOngoing="modalSignOngoingOn()"
          @signDisabled="modalSignOngoingOff()"
        ></sign-modal-form>
      </p>
    </b-modal>
  </b-row>
</template>

<script>
import ActivityModalForm from "@/views/policy/components/ActivityModalForm";
import SignModalForm from "@/views/policy/components/SignModalForm";
import Activity from "@/models/Activity";
import { ACTIVITY_STATUS_TYPES, ACTIVITY_CONTROLLED_STATUS_TYPES } from "@/constants";
import ActivityService from "@/services/ActivityService";

export default {
  name: "activityList",
  components: { ActivityModalForm, SignModalForm },
  props: {
    activities: {
      type: Array
    },
    info: {
      type: Object,
      default: null
    },
    protocol: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    p_printActivities: {
      type: Boolean,
      default: false
    },
    p_showByDefault: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      signActivities: [],
      showActivityModal: false,
      showSignModal: false,
      editedActivity: null,
      stageActivity: null,
      editedActivityIndex: null,
      showReviewers: false,
      saveEnabled: false,
      disableModalSave: false,
      loading: false,
      showVisibilityInfo: false,
      showListDefault: true,
      showOnlyActive: false
    };
  },
  mounted() {
    this.signActivities = this.activities;

    if(this.info)
    {
      this.showOnlyActive = true;
    }

    if(this.filteredActivities.length > 0)
    {
      this.showVisibilityInfo = true;
      this.$emit('activities-loaded', this.filteredActivities.length);
    }

    if(this.info && this.activeActivities.length == 0 && !this.p_showByDefault)
    {
      this.showListDefault = false;
    }
  },
  watch: {
    activities(activities) {
      this.signActivities = activities;

      if (this.editedActivityIndex != null) {
        this.editedActivity = this.filteredActivities[this.editedActivityIndex];

      }
    }
  },
  computed: {
    filteredActivities() {
      return this.signActivities.filter((item) => {
        return (this.showReviewers || item.activity_type != "1") && (!this.showOnlyActive || item.status < ACTIVITY_STATUS_TYPES.WONT_DO);
      });
    },
    reviewActivities() {
      return this.signActivities.filter((item) => {
        return item.activity_type == "1";
      });
    },
    activeActivities() {
      return this.activities.filter((item) => {
        return item.status < ACTIVITY_STATUS_TYPES.WONT_DO;
      });
    },
    isInfoObject() {
      return this.info != null ? true : false;
    },
    editAllowed() {
      if (this.isInfoObject) {
        return this.info.can_edit;
      } else {
        return true;
      }
    },
    saveAllowed() {
      if (this.isInfoObject) {
        return (
          (this.$userCan("change_info") &&
            (this.$userIsCompanyAdmin() ||
              (this.info.responsible != null && this.$user.person == this.info.responsible.id))) ||
          this.activityResponsible
        );
      } else {
        return this.$userIsCompanyAdmin() || this.activityResponsible;
      }
    },
    activityResponsible() {
      return (
        this.editedActivity != null &&
        (this.editedActivity.responsible == null ||
          (this.editedActivity.responsible != null && this.$user.person == this.editedActivity.responsible.id) ||
          (this.editedActivity.status > 2 &&
            this.editedActivity.controller != null &&
            this.$user.person == this.editedActivity.controller.id))
      );
    },
    isController() {
      return (
        this.editedActivity != null &&
        this.editedActivity.controller != null &&
        this.$user.person == this.editedActivity.controller.id
      );
    }
  },
  methods: {
    editActivity(activity = null, index = null) {
      if (!this.loading) {
        this.editedActivity = activity ? activity : new Activity({});
        this.stageActivity = activity ? new Activity(activity) : null;
        this.editedActivityIndex = index;

        if (this.editedActivity.activity_type == 1) {
          if (this.editAllowed) {
            this.showSignModal = true;
          }
        } else {
          this.showActivityModal = true;
        }
      }
    },
    saveActivity() {
      if (this.editedActivityIndex === null && this.saveEnabled) {
        this.activities.push(this.editedActivity);
      }
      if ((this.info == null || !this.info.isNew) && this.saveEnabled) {
        if (this.editAllowed) {
          if (this.isController) {
            this.updateActivity();
          } else {
            this.$emit("saved");
          }
        } else {
          this.updateActivity();
        }
      }
      this.closeModal();
    },
    cancel() {
      if (this.editedActivityIndex != null) {
        this.filteredActivities[this.editedActivityIndex] = this.stageActivity;
        let idx = this.activities.indexOf(this.activities.find((item) => item.id == this.stageActivity.id));
        this.activities[idx] = this.stageActivity;
      }
      this.closeModal();
    },
    closeModal() {
      this.editedActivity = null;
      this.editedActivityIndex = null;
      this.showActivityModal = false;
      this.showSignModal = false;
      this.stageActivity = null;
    },
    signedActivity() {
      if (this.editAllowed) {
        this.$emit("saved");
      } else {
        this.updateActivity();
      }
    },
    modalSignOngoingOn() {
      this.disableModalSave = true;
    },
    modalSignOngoingOff() {
      this.disableModalSave = false;
    },
    updateActivity() {
      this.loading = true;

      if (this.isInfoObject) {
        this.editedActivity.info = { id: this.info.id };
      }

      ActivityService.updateActivity(this.editedActivity.id, this.editedActivity)
        .then((activity) => {
          this.$bvToast.toast(this.$t("savedInfoGeneric"), {
            title: this.$t("saved"),
            variant: "success"
          });
        })
        .finally((this.loading = false));
    },
    rowClass2(item) {
      if (item.isOverdue && item.status < ACTIVITY_STATUS_TYPES.WONT_DO) {
        return "danger";
      } else if (item.isNextWeek && item.status < ACTIVITY_STATUS_TYPES.WONT_DO) {
        return "warning";
      } else if (item.status == ACTIVITY_STATUS_TYPES.DONE) {
        if (item.controller == null || item.controlled_status == ACTIVITY_CONTROLLED_STATUS_TYPES.APPROVED) {
          return "success";
        } else {
          return "warning";
        }
      }
      return "light";
    },
    rowClass(item) {
      if (
        (item.isOverdue && item.status < ACTIVITY_STATUS_TYPES.WONT_DO) ||
        item.status == ACTIVITY_STATUS_TYPES.WONT_DO
      ) {
        return "danger";
      } else if (item.isNextWeek && item.status < ACTIVITY_STATUS_TYPES.WONT_DO) {
        return "warning";
      } else if (item.status == ACTIVITY_STATUS_TYPES.DONE) {
        return "success";
      }
      return "light";
    },
    enableSave(enable) {
      this.saveEnabled = enable;
    },
    setVisibilityInfo() {
      this.showVisibilityInfo = !this.showVisibilityInfo;
    },
  },
  emit: ['activities-loaded'],
};
</script>
<style scoped lang="scss">
@media print {
  table {
  border: none;
  border-collapse: collapse;
}

table td, table th {
  border: none;
}
}
</style>
